// extracted by mini-css-extract-plugin
export default {"icon":"Loading_icon__XAFEo","container":"Loading_container__8fuVK","load":"Loading_load__h9uVH"};